import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_SECRET_AES; // Keep this safe and complex

export function encryptValue(value) {
  if (!value || typeof value !== 'string') {
    console.error('encryptValue: Invalid value passed for encryption:', value);
    return '';
  }
  const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
  return encodeURIComponent(encrypted);
}

export function parseAndDecryptFromState(queryString) {
  if (!queryString || typeof queryString !== 'string') {
    console.warn('Query string is empty or invalid.');
    return null;
  }

  const params = new URLSearchParams(queryString);
  const encrypted = params.get('enc');

  if (!encrypted) {
    console.warn('No "enc" parameter found.');
    return null;
  }

  let decryptedDashIdPart = '';
  try {
    const decoded = decodeURIComponent(encrypted);
    const bytes = CryptoJS.AES.decrypt(decoded, SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8); // e.g. "dash_id=234"

    if (!decryptedText.includes('=')) {
      throw new Error('Invalid decrypted value.');
    }

    decryptedDashIdPart = decryptedText;
  } catch (err) {
    console.error('Decryption failed:', err.message);
    return null;
  }

  // Reconstruct full query string: start with decrypted part
  let fullQuery = decryptedDashIdPart;

  // Add the remaining parameters (excluding 'enc')
  for (const [key, value] of params.entries()) {
    if (key !== 'enc') {
      fullQuery += `&${key}=${decodeURIComponent(value)}`;
    }
  }

  return fullQuery;
}

export function buildEncryptedQueryString(params) {
  if (!params?.dash_id) {
    console.error('Missing dash_id for encryption.');
    return '';
  }

  // Encrypt only dash_id part like "dash_id=234"
  const encryptedDashId = encryptValue(`dash_id=${params.dash_id}`);

  // Start query string with encrypted part
  let query = `?enc=${encryptedDashId}`;

  // Add remaining parameters (excluding dash_id) using encodeURIComponent
  Object.entries(params).forEach(([key, value]) => {
    if (key !== 'dash_id') {
      query += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }
  });

  return query;
}